import { ComparatorReturns } from '@list-store';
import {
    alphabeticalStringComparator,
    alphanumericStringComparator,
    numberComparator,
} from '../../common/sorting/comparators';
import { SortDirection, SortType } from '../../common/sorting/types';

export const createSortComparator = (direction: SortDirection, sortType: SortType) => (
    leftValue: string | number | undefined,
    rightValue: string | number | undefined
): ComparatorReturns => {
    // we cannot compare against undefined values so we just set them to empty strings
    if (typeof leftValue === 'undefined') {
        leftValue = '';
    }
    if (typeof rightValue === 'undefined') {
        rightValue = '';
    }

    const isAscending = direction === 'asc';
    if (typeof leftValue === 'string' || typeof rightValue === 'string') {
        const comparator =
            sortType === 'alphanumeric'
                ? alphanumericStringComparator
                : alphabeticalStringComparator;
        const result = comparator(`${leftValue}`, `${rightValue}`);
        return (isAscending ? result : result * -1) as ComparatorReturns;
    } else {
        const result = numberComparator(leftValue, rightValue);
        return (isAscending ? result : result * -1) as ComparatorReturns;
    }
};
